import { injectGlobal } from 'styled-components'
import 'antd/dist/antd.css'
export default () => injectGlobal`
  html {
    /* stylelint-disable property-no-vendor-prefix, declaration-property-unit-whitelist */
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    
    /* Do this to prevent marketplace menu to be resized */
    /* stylelint-disable declaration-no-important */
    font-size: 16px !important;
    line-height: 1;
    font-family: Lato;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    /* stylelint-enable */
  }
  body {
    margin: 0;
  }
  h1,
  h2,
  h3,
  h4,
  p,
  blockquote,
  figure,
  ol,
  ul {
    margin: 0;
    padding: 0;
  }
  main,
  li {
    display: block;
  }
  h1,
  h2,
  h3,
  h4 {
    font-size: inherit;
  }
  strong {
    font-weight: 700;
  }
  a,
  button {
    color: inherit;
    transition: .3s;
  }
  a {
    text-decoration: none;
  }
  button {
    overflow: visible;
    border: 0;
    font: inherit;
    -webkit-font-smoothing: inherit;
    letter-spacing: inherit;
    background: none;
    cursor: pointer;
  }
  ::-moz-focus-inner {
    padding: 0;
    border: 0;
  }
  :focus {
    outline: 0;
  }
  img {
    max-width: 100%;
    height: auto;
    border: 0;
  }

  body {
    min-height: 100%;
  }

  /* stylelint-disable selector-max-id */
  #root {
    display: flex;
    flex-direction: column;
    background-color: white;
    min-height: 100%;
    height: 100%;

    @supports (display: grid) {
      height: initial;
    }
  }
  /* stylelint-enable selector-max-id */

  /* OVERRIDE WORDPRESS STYLE START, ONLY use this if some css style of wordpress is not rendered correctly (table-cell) */
  .team-item .team-avatar {
    min-width: 220px
  }

  /* OVERRIDE WORDPRESS STYLE END */
`



// WEBPACK FOOTER //
// ./src/style.tsx